import { render } from "./Cafetantan.vue?vue&type=template&id=768bab57&scoped=true"
import script from "./Cafetantan.vue?vue&type=script&lang=js"
export * from "./Cafetantan.vue?vue&type=script&lang=js"

import "./Cafetantan.vue?vue&type=style&index=0&id=768bab57&scoped=true&lang=css"

import exportComponent from "D:\\pro\\node-workspace\\machitabi_Vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768bab57"]])

export default __exports__